import React from "react";
import { Icon, IconBaseProps } from "./Icon";

const MenuIcon: React.FC<IconBaseProps> = props => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g className="nc-icon-wrapper">
      <path d="M8.25 6.003A2.252 2.252 0 0 1 6 3.753v-1.5A2.252 2.252 0 0 1 8.25.003h13.5A2.252 2.252 0 0 1 24 2.253v1.5a2.252 2.252 0 0 1-2.25 2.25H8.25zm0-4.5a.75.75 0 0 0-.75.75v1.5c0 .414.336.75.75.75h13.5a.75.75 0 0 0 .75-.75v-1.5a.75.75 0 0 0-.75-.75H8.25z" />
      <path d="M5.25 15.003A2.252 2.252 0 0 1 3 12.753v-1.5a2.252 2.252 0 0 1 2.25-2.25h13.5a2.252 2.252 0 0 1 2.25 2.25v1.5a2.252 2.252 0 0 1-2.25 2.25H5.25zm0-4.5a.75.75 0 0 0-.75.75v1.5c0 .414.336.75.75.75h13.5a.75.75 0 0 0 .75-.75v-1.5a.75.75 0 0 0-.75-.75H5.25z" />
      <path d="M2.25 24.003A2.252 2.252 0 0 1 0 21.753v-1.5a2.252 2.252 0 0 1 2.25-2.25h13.5a2.252 2.252 0 0 1 2.25 2.25v1.5a2.252 2.252 0 0 1-2.25 2.25H2.25zm0-4.5a.75.75 0 0 0-.75.75v1.5c0 .414.336.75.75.75h13.5a.75.75 0 0 0 .75-.75v-1.5a.75.75 0 0 0-.75-.75H2.25z" />
    </g>
  </Icon>
);

export default MenuIcon;
